<template>
  <div>
    <table class="table table-sm table-hover table-bordered">
      <thead>
      <tr>
        <th width="50px"></th>
        <th>Менеджер</th>
        <th>Помощник</th>
      </tr>
      </thead>
      <tbody>
      <tr v-for="(user, id, index) in users" v-if="user.is_active">
        <td>{{ index + 1 }}</td>
        <td>
          <div>
            <button
              v-if="editUser"
              @click="editUser(user)"
              class="btn btn-xs btn-info pull-left mr-2"
            >
              <i class="icon-fa icon-fa-eye"></i>
            </button>
            <div class="flex">
              <UserInfo :user="user" class="mr-2"/>
              <UserTags :tags="getDetailByAlias(user, 'user_tags')"/>
            </div>
            <div>
              <span class="badge badge-success mr-1" v-for="record in getDetailByAlias(user, 'order_access')">{{
                  record.project_id === 'all' ? 'Все проекты' : $AllProjects[record.project_id].name
                }}</span>
            </div>
          </div>
        </td>
        <td>
          <template v-if="sortedAssistance[user.id] && sortedAssistance[user.id].length">
            <div v-for="assist in sortedAssistance[user.id]" v-if="assist.is_active">
              <button
                v-if="editUser"
                @click="editUser(assist)"
                class="btn btn-xs btn-info pull-left mr-2"
              >
                <i class="icon-fa icon-fa-eye"></i>
              </button>
              <UserInfo :user="assist"/>
              <UserTags :tags="getDetailByAlias(assist, 'user_tags')"/>
              <div>
              <span class="badge badge-success mr-1" v-for="record in getDetailByAlias(assist, 'order_access')">{{
                  record.project_id === 'all' ? 'Все проекты' : $AllProjects[record.project_id].name
                }}</span>
              </div>

            </div>
          </template>
        </td>
      </tr>
      </tbody>
    </table>

    <h5>Помощники без привязки к менеджеру</h5>
    <table class="table table-hover table-sm" v-if="Object.keys(freeAssists).length">
      <tbody>
      <tr v-for="(assist, index) in freeAssists">
        <td width="70px">{{ index + 1 }}</td>
        <td>
          <div>
            <button
              v-if="editUser"
              @click="editUser(assist)"
              class="btn btn-xs btn-info pull-left mr-2"
            >
              <i class="icon-fa icon-fa-eye"></i>
            </button>
            <UserInfo :user="assist"/>
            <UserTags :tags="getDetailByAlias(assist, 'user_tags')"/>
            <div>
              <span class="badge badge-success mr-1" v-for="record in getDetailByAlias(assist, 'order_access')">{{
                  record.project_id === 'all' ? 'Все проекты' : $AllProjects[record.project_id].name
                }}</span>
            </div>

          </div>
        </td>
      </tr>
      </tbody>
    </table>
  </div>
</template>

<script>

import UserInfo from "@/views/users/components/UserInfo";
import UserTags from "@/views/users/components/UserTags";

export default {
  components: {
    UserInfo,
    UserTags,
  },
  props: [
    'users', 'assists', 'editUser'
  ],
  computed: {
    $AllProjects() {
      return this.$store.getters['platform/projects'].reduce((acc, p) => {
        acc[p.id] = p
        return acc;
      }, {});
    },
  },
  data() {
    return {
      sortedAssistance: {},
      freeAssists: []
    }
  },
  created() {
    this.sortAssistances()
  },
  methods: {
    sortAssistances() {
      let freeAssists = [];
      const sorted = Object.keys(this.assists).reduce((acc, id) => {
        const managerId = this.getDetailByAlias(this.assists[id], 'assist_to_user');
        if (managerId) {
          if (!acc[managerId]) acc[managerId] = [];
          acc[managerId].push(this.assists[id])
        } else {
          freeAssists.push(this.assists[id]);
        }
        return acc;
      }, {})
      this.freeAssists = freeAssists;
      this.sortedAssistance = sorted;
    },
    getDetailByAlias(user, alias) {
      let value = false;
      user.details.forEach((d) => {
        if (d.alias === alias) {
          value = d.details;
        }
      });
      if (value && typeof value == 'object' && !value.length) {
        value = false;
      }
      return value;
    }
  }
}

</script>
